import { getRegularRouteMarkersByTimeBand } from "../../reducers/matrixProfile/selectors";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../theme/palette";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
  },
  routesContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "0 30px 0 30px",
    height: "15px",
    color: palette.typography.white.inactive,
  },
  routesItem: {
    fontSize: "11px",
    textAlign: "center",
    position: "relative",
  },
  routesText: {
    position: "absolute",
    left: "-10px",
    fontWeight: "bold",
    color: palette.typography.white.high,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    width: "20px",
  },
});

export const RoutesCounts = ({ marks, onClick }) => {
  const styles = useStyles();
  const routeCountsByTimeBand = useSelector(getRegularRouteMarkersByTimeBand);

  const routeCount = (mark) => {
    return (
      (routeCountsByTimeBand &&
        routeCountsByTimeBand[mark.value] &&
        routeCountsByTimeBand[mark.value].length) ||
      0
    );
  };

  const routesMarker = (mark) => {
    let routesCount = routeCount(mark);

    if (routesCount === 0) {
      return "";
    } else if (routesCount < 10) {
      return `0${routesCount}`;
    } else {
      return routesCount + "";
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.routesContainer}>
        {marks.map((mark, index) => {
          return (
            <div key={index} className={styles.routesItem}>
              <div
                className={styles.routesText}
                onClick={(event) => {
                  onClick && onClick(event, mark.value);
                }}
              >
                {routesMarker(mark)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
